<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChromeLogo_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M20.604 6.903a.164.164 0 0 1-.141.247h-8.04a4.87 4.87 0 0 0-5.139 3.634.164.164 0 0 1-.3.041L4.169 5.95a.16.16 0 0 1 .014-.184A9.96 9.96 0 0 1 12 2.001a9.99 9.99 0 0 1 8.604 4.902M12 15.738A3.74 3.74 0 0 1 8.263 12 3.74 3.74 0 0 1 12 8.263a3.74 3.74 0 0 1 3.737 3.738A3.74 3.74 0 0 1 12 15.738m1.478 1.012a.16.16 0 0 0-.174-.058A4.9 4.9 0 0 1 12 16.87a4.89 4.89 0 0 1-4.416-2.818L3.568 7.096a.164.164 0 0 0-.285.001 10.005 10.005 0 0 0 7.225 14.793.17.17 0 0 0 .166-.08l2.816-4.878a.16.16 0 0 0-.012-.182m2.043-8.506h5.638c.067 0 .128.042.153.104A10 10 0 0 1 22 12.001a9.94 9.94 0 0 1-2.892 7.033 9.94 9.94 0 0 1-6.995 2.965h-.001a.164.164 0 0 1-.142-.246l4.022-6.967.008-.012c.569-.818.87-1.777.87-2.773 0-1.317-.52-2.551-1.463-3.476a.164.164 0 0 1 .114-.28"
        clip-rule="evenodd"
    />
</svg>
